import Vue from 'vue'
import {
  // MessageBox,
  Button,
  Form,
  FormItem,
  Input,
  Message,
  // Container,
  // Header,
  // Aside,
  // Main,
  // Menu,
  // Submenu,
  // MenuItem,
  // Breadcrumb,
  // BreadcrumbItem,
  Card,
  Row,
  Col,
  Table,
  TableColumn,
  // Switch,
  // Tooltip,
  Pagination,
  Dialog,
  Tag,
  Alert,
  // Cascader,
  Tabs,
  TabPane,
  // Steps,
  // Step,
  Select,
  Option,
  CheckboxGroup,
  Checkbox,
  // Upload,
  // Link,
  // TimelineItem,
  // Timeline,
  // Avatar,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  RadioGroup,
  Radio,
  // Divider,
  // Progress,
  // Autocomplete,
  Image,
  // Drawer,
  DatePicker,
  Carousel,
  CarouselItem,
  // Tree,
  // Empty,
  // Transfer,
  // InputNumber,
  // Collapse,
  // CollapseItem,
  // Popover,
  // InfiniteScroll,
  Loading,
  // ColorPicker,
  // TimeSelect,
  // TimePicker,
} from 'element-ui'

Vue.use(Button)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
// Vue.use(Container)
// Vue.use(Header)
// Vue.use(Aside)
// Vue.use(Main)
// Vue.use(Menu)
// Vue.use(Submenu)
// Vue.use(MenuItem)
// Vue.use(Breadcrumb)
// Vue.use(BreadcrumbItem)
Vue.use(Card)
Vue.use(Row)
Vue.use(Col)
Vue.use(Table)
Vue.use(TableColumn)
// Vue.use(Switch)
// Vue.use(Tooltip)
Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(Tag)
Vue.use(Alert)
// Vue.use(Cascader)
Vue.use(Tabs)
Vue.use(TabPane)
// Vue.use(Steps)
// Vue.use(Step)
Vue.use(Select)
Vue.use(Option)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
// Vue.use(Upload)
// Vue.use(Link)
// Vue.use(Timeline)
// Vue.use(TimelineItem)
// Vue.use(Avatar)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(RadioGroup)
Vue.use(Radio)
// Vue.use(Divider)
// Vue.use(Progress)
// Vue.use(Autocomplete)
Vue.use(Image)
// Vue.use(Drawer)
Vue.use(DatePicker)
Vue.use(Carousel)
Vue.use(CarouselItem)
// Vue.use(Tree)
// Vue.use(Empty)
// Vue.use(Transfer)
// Vue.use(InputNumber)
// Vue.use(Collapse)
// Vue.use(CollapseItem)
// Vue.use(Popover)
// Vue.use(InfiniteScroll)
Vue.use(Loading)
// Vue.use(ColorPicker)
// Vue.use(TimeSelect)
// Vue.use(TimePicker)
Vue.prototype.$message = Message
// Vue.prototype.$alert = MessageBox.alert
// Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$Loading =Loading.service
